import React, { useState } from 'react';
import styled from 'styled-components';

interface CheckboxProps {
  label: string;

  updateFunc: (newCheckedState: boolean) => void;
  defaultValue?: boolean;
}

const CheckboxWrapper = styled.div`
  display: inline-block;
  align-items: center;
`;

const CheckIcon = styled.i(({ theme }) => {
  return `
        color: ${theme.color.grayscale[900]};
        font-size: ${theme.type.size.tiny};
        position: relative;
        top: -9px;
        left: 4px;
    `;
});

const CheckboxLabel = styled.label`
  position: relative;
  padding-left: 25px;
  cursor: pointer;
`;

const CheckboxIcon = styled.div(({ theme }) => {
  return `
    content: '';
    position: absolute;
    left: 0;
    top: 6px;
    width: 20px;
    height: 20px;
    border: 1px solid ${theme.color.grayscale[200]};
    &.checked {
        background: ${theme.color.grayscale.black};
        border: none;
    }
    
    border-radius: 1000px;
  `;
});

const CheckboxInput = styled.input`
  display: none;
`;

const CheckboxText = styled.span(({ theme }) => {
  return `
      font-weight: bold;
      font-size: ${theme.type.size.large};
      text-align: left;
      margin-left: 5px;
    `;
});

const Checkbox: React.FC<CheckboxProps> = ({ label, updateFunc, defaultValue = false }) => {
  const [isChecked, setIsChecked] = useState(defaultValue);

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
    updateFunc(!isChecked);
  };

  return (
    <CheckboxWrapper>
      <CheckboxInput id={label} type="checkbox" checked={isChecked} onChange={handleCheckboxChange} />
      <CheckboxLabel htmlFor={label}>
        <CheckboxIcon className={isChecked ? 'checked' : ''}>
          {isChecked && <CheckIcon className="fa fa-check" />}
        </CheckboxIcon>

        <CheckboxText>{label}</CheckboxText>
      </CheckboxLabel>
    </CheckboxWrapper>
  );
};

export default Checkbox;
